module.exports = __webpack_public_path__ + "static/media/auth.a9f31ea3.png";